import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import authReducer from './store/reducers/auth';
import ui from './store/reducers/ui';
import transferThings from './store/reducers/transferThings';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';
import Main from './Components/Boilerplates/Main/Main';

const rootReducer = combineReducers({
  modal: ui.modal,
  showError: ui.showError,
  isLoading: ui.isLoading,
  auth: authReducer,
  thing: transferThings,
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(rootReducer, /* preloadedState, */ composeEnhancers(applyMiddleware(thunk)));

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter basename='/#'>
      <React.StrictMode>
        <Main>
          <App />
        </Main>
      </React.StrictMode>
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
